import { ethers } from "ethers";

// Returns the injected EIP-1193 provider object (window.ethereum).
// Works with MetaMask, Trust Wallet in-app browser, Binance Wallet, and
// other mobile DEX wallets that inject window.ethereum.
export function getInjectedProvider() {
  if (typeof window === "undefined") return null;

  // Some wallets expose multiple providers in window.ethereum.providers
  const eth = window.ethereum;
  if (!eth) return null;

  if (Array.isArray(eth.providers) && eth.providers.length) {
    // Prefer the one the user is actively using; fall back to first.
    return (
      eth.providers.find((p) => p.isMetaMask) ||
      eth.providers.find((p) => p.isTrust || p.isTrustWallet) ||
      eth.providers[0]
    );
  }
  return eth;
}

export function hasInjectedWallet() {
  return !!getInjectedProvider();
}

// ethers v5 Web3Provider wrapper around the injected provider.
export function getEthersProvider() {
  const injected = getInjectedProvider();
  if (!injected) return null;
  return new ethers.providers.Web3Provider(injected, "any");
}
